import React from 'react'; // eslint-disable-line

const DeleteDialog = (props) => {
    return (
        <div>
            <div className="open-text">{props.message}
                {props.warning && <span className="warning">{props.warning}</span>}
            </div>
        </div>
    );
};

export default DeleteDialog;
